<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item active">Solicitudes</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-address-book"></i> Solicitudes<small> </small></h1>
<!-- end page-header -->
<div class="card border-0 mb-4">

    <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <div class="col-md-8">
            <i class="fas fa-user text-gray text-opacity-50"></i>
            Listado de Solicitudes
        </div>
        <button class="btn btn-white btn-sm border-0 text-gray" (click)="exportRequests()"> <i
                class="fas fa-file-excel text-green"></i> Exportar </button>

    </div>


    <div class="card-body p-3 text-dark fw-bold row">
        <div class="mt-2 col-xxl-2 col-xl-3 col-lg-4 col-sm-12 ">
            Tipo Solicitud
            <ng-select class="ng-select-sm" [items]="listMovements" bindLabel="name" bindValue="_id"
                [(ngModel)]="params.movementId" placeholder="Seleccione tipo de Solicitud"></ng-select>
        </div>
        <div class="mt-2 col-xxl-2 col-xl-3 col-lg-4 col-sm-6 ">
            Desde
            <input type="date" class="form-control form-control-sm" placeholder="Buscar desde"
                [(ngModel)]="params.since">
        </div>
        <div class="mt-2 col-xxl-2 col-xl-3 col-lg-4 col-sm-6 ">
            Hasta
            <input type="date" class="form-control form-control-sm" placeholder="Buscar Hasta"
                [(ngModel)]="params.until">
        </div>
        <div class="mt-2 col-xxl-2 col-xl-3 col-lg-4 col-sm-6 d-flex align-items-end">
            <button class="btn btn-primary btn-sm" (click)="findSearch(1)">Buscar</button>
        </div>

    </div>
    <hr>
    <div class="card-body p-3 text-dark fw-bold">
        @if(listRequestsTemp.length > 0){

        <div class="row d-flex justify-content-between">
            <div class="col-sm-12 col-lg-9">
                <div class="row g-2">
                    <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                        <ng-select [items]="searchByFilter" [clearable]="false" [(ngModel)]="params.searchBy"
                            name="searchBy"></ng-select>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-5 col-12">
                        <input type="text" class="form-control" placeholder="Ingrese criterio de búsqueda"
                            [(ngModel)]="params.search">
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-3 col-12">
                        <button class="btn btn-primary w-100" (click)="findSearch(1)"> <i class="fas fa-search"></i>
                            Buscar</button>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 col-sm-12 d-flex justify-content-sm-start justify-content-lg-end align-items-center mt-2 mt-lg-0">

                <span class="text-nowrap me-1">Mostrar: </span>
                <div class="page-size">
                    <select class="form-select form-select-sm" [(ngModel)]="params.pageSize"
                        (ngModelChange)="findSearch(1)">
                        <option value="10">10 registros </option>
                        <option value="25">25 registros </option>
                        <option value="50">50 registros </option>
                        <option value="100">100 registros </option>
                        <option value="150">150 registros </option>
                        <option value="200">200 registros </option>
                    </select>
                </div>
            </div>
        </div>

        }
        <div class="row  m-3 table-responsive table-responsive-sm">
            <table class="table table-sm table-hover">
                <thead class="fixed-header">
                    <tr>
                        <th>N°</th>
                        <th class="text-center text-nowrap">Nombre Completo</th>
                        <th class="text-center text-nowrap">Movimiento</th>
                        <th class="text-center text-nowrap">Póliza</th>
                        <th class="text-center text-nowrap">Grupo</th>
                        <th class="text-center text-nowrap">Capital</th>
                        <th class="text-center text-nowrap">Fecha Solicitud</th>
                        <th class="text-center text-nowrap">Fecha Exportación</th>
                        <th class="text-center text-nowrap">Estado</th>
                        <th class="text-center">Acción</th>
                    </tr>
                </thead>
                @if(listRequests.length > 0){
                <tbody>
                    @for(p of listRequests; track p._id; let i = $index){
                    <tr [ngClass]="{'table-success': p.state?.stage >= 3, 'table-danger': p.state?.stage === -1}">
                        <td>{{ (params.page - 1) * params.pageSize + (i + 1) }}</td>
                        <td class=" text-nowrap">{{p.insured?.names}} {{p.insured?.surname}} {{p.insured?.lastname}}</td>
                        <td class="text-center text-nowrap">{{p.movement.name}}</td>
                        @if(p.contract){
                        <td class="text-center text-nowrap">{{p.contract.policy.code}}
                            @if(p.contract.policy.code != p.policy.code){ <i
                                class="fas fa-angles-right"></i> {{p.policy.code}} }</td>
                        <td class="text-center text-nowrap">{{p.contract.group?.name}} @if(p.contract.group?.name !=
                            p.group?.name){ <i class="fas fa-angles-right"></i> {{p.group?.name}} }</td>
                        <td class="text-center text-nowrap">{{p.contract.capital}} @if(p.contract.capital != p.capital){
                            <i class="fas fa-angles-right"></i> {{p.capital}} }</td>
                        }@else{
                        <td class="text-center text-nowrap">{{p.policy.code}}</td>
                        <td class="text-center text-nowrap">{{p.group?.name}}</td>
                        <td class="text-center text-nowrap">{{p.capital}}</td>
                        }
                        <td class="text-center">{{p.dateRequest | date: "dd-MM-yyyy": "UTC"}}</td>
                        <td class="text-center">{{p.dateExport | date: "dd-MM-yyyy": "UTC"}}</td>
                        <td class="text-center">
                            <span
                                class="btn badge d-inline-flex rounded btn-xs align-items-center"
                                [ngClass]="p.state?.stage > 1 ? 'btn-outline-success text-success bg-white' : ['btn-outline-secondary text-secondary bg-white', p.state?.class]">
                                <i class="fas fa-circle mt-1 mx-1"></i> {{p.state.name}}
                            </span>
                        </td>
                        <td class="text-center text-nowrap">
                            <button class="btn btn-warning btn-xs btn-rounded"
                                (click)="setRequest(p, modalRequest)"><i class="fas fa-eye"></i></button>
                            @if(canCancel(p)){
                            <button class="btn btn-danger btn-xs btn-rounded ms-1" (click)="reject(p)"><i
                                    class="fas fa-trash"></i></button>
                            }

                        </td>
                    </tr>
                    }

                </tbody>
                }@else {
                <tbody>
                    <tr>
                        <td colspan="10" class="text-center">No existen datos para estos criterios de búsqueda</td>
                    </tr>
                </tbody>
                }
            </table>
        </div>
        @if(listRequests.length > 0){
        <div class="d-flex justify-content-between">
            <span>Mostrando {{page}} de {{totalPages}}</span>
            <ngb-pagination [(page)]="page" [pageSize]="params.pageSize" [collectionSize]="totalResult" size="sm"
                [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="findSearch($event)"></ngb-pagination>
        </div>
        }
    </div>
</div>


<ng-template #modalRequest let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between">
        <span class="fs-4 fw-600">{{requestSel.movement.name}}</span>
        <div>
            <span class="fs-5 fw-600 mx-3">Fecha Solicitud: {{requestSel.dateRequest | date: "dd-MM-yyyy": "UTC"}}</span>
            <button type="button" class="close btn btn-sm btn-white m-r-1" (click)="d('Cross click')"><span
                    aria-hidden="true">&times;</span></button>
        </div>

    </div>
    <div class="modal-scrollable">
        <app-review-request [requestModel]="requestSel" (updateRequest)="getRequest()"></app-review-request>
    </div>


</ng-template>